import { rem } from 'polished'
import styled from 'styled-components'
import { DRAWER_DETAIL_CONTENT_WIDTH } from '../constants'
import { DrawerBodyContentWrapper } from '../drawerBodyLayout.styles'
import { HOTEL_DRAWER_CONTENT_CONTAINER_NAME } from './constants'

export const ContentWrapper = styled(DrawerBodyContentWrapper)`
  container: ${HOTEL_DRAWER_CONTENT_CONTAINER_NAME} / inline-size;
  max-width: ${rem(DRAWER_DETAIL_CONTENT_WIDTH)};
`
